module.exports = __webpack_public_path__ + "static/8-a8ddf42bfec45c0c331c106aefc8a480.png";